import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAgentEntity } from './conversation-agent.entity';
import { UserEntity } from './user.entity';

/**
 * PD-16920 — a user's own pick of in-app assistant (the chat widget's agent).
 * One live row per user. It outranks the user's role default and the tenant
 * default; a pick that stops being usable (the agent is deactivated, deleted
 * or no longer for internal staff) is skipped and the next level decides.
 * Mirrors `_conversation_agent_role_default` (table name included, so the
 * two sit together); the columns follow the current naming rule.
 */
@Entity('_conversation_agent_user_default')
@Index('uk_user_active', ['fkUserId', 'deletedDate'], { unique: true })
@Index('idx_agent', ['conversationAgentId'])
@Index('idx_user', ['fkUserId'])
export class ConversationAgentUserDefaultEntity extends BaseEntity {
	@Column({
		name: 'fk__conversation_agent__id',
		type: 'int',
		unsigned: true,
		nullable: false,
	})
	public conversationAgentId!: number;

	/** The tenant user (`_user._id`, the instance user id). */
	@Column({
		name: 'fk_user__id',
		type: 'int',
		unsigned: true,
		nullable: false,
	})
	public fkUserId!: number;

	@ManyToOne(() => ConversationAgentEntity, { onDelete: 'CASCADE' })
	@JoinColumn({ name: 'fk__conversation_agent__id' })
	public agent?: ConversationAgentEntity;

	@ManyToOne(() => UserEntity, { onDelete: 'CASCADE' })
	@JoinColumn({ name: 'fk_user__id' })
	public user?: UserEntity;
}
